<template>
	<v-chip :color="info.color" :small="small" :to="to" dark label>
		{{ info.text }}
	</v-chip>
</template>

<script>
import { stageInfo } from "@/utils/works";

export default {
	name: "WorkStageChip",
	props: {
		stage: { type: String, required: true },
		small: { type: Boolean, default: false },
		to: { type: [String, Object], default: null },
	},
	computed: {
		info() {
			return stageInfo(this.stage);
		},
	},
};
</script>
